export default "__VITE_ASSET__795c1a57__"